// src/pages/BillingProcessing.js
import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchPlanStatus } from '../services/billingService';

/**
 * Página mostrada tras volver de Tiendanube Billing.
 * Hace polling hasta que el plan deje de ser 'trial' o se marque 'cancelled'.
 */
export default function BillingProcessing() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    async function poll() {
      try {
        const status = await fetchPlanStatus();
        if (status.plan && status.plan !== 'trial' && status.plan !== 'free') {
          navigate('/billing', { replace: true });
        } else {
          setTimeout(() => !cancelled && poll(), 4000);
        }
      } catch (e) {
        console.error('[BillingProcessing] error', e);
        setTimeout(() => !cancelled && poll(), 6000);
      }
    }
    poll();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Box textAlign="center" pt={6}>
      <CircularProgress />
      <Typography variant="h6" mt={2}>
        Confirmando tu pago...
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Esto puede tardar unos segundos. No cierres esta pestaña.
      </Typography>
    </Box>
  );
}
